import { render, staticRenderFns } from "./AddRuleDialog.vue?vue&type=template&id=efe83a02&scoped=true"
import script from "./AddRuleDialog.vue?vue&type=script&lang=js"
export * from "./AddRuleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe83a02",
  null
  
)

export default component.exports